import React, { Component } from 'react';
import './App.css';
import { Link } from 'react-router';
import firebase from 'firebase';
import Login from './Login';
import { Page } from 'hedron';
import { Button } from '@blueprintjs/core';

class App extends Component {

  constructor(props) {
    super(props);

    this.state = {
      database: null,
      isLoggedIn: false,
    }
  }

  componentWillMount() {

    firebase.auth().onAuthStateChanged((user) => {
      this.setState({
        isLoggedIn: !!user,
      });
    });
  }

  render() {
    const content = (this.state.isLoggedIn) ? this.props.children : <Login />;
    const leftButtons = (this.state.isLoggedIn) ? (
      <Link className="pt-button pt-minimal pt-icon-people" to="/customers"></Link>
    ) : null;
    const rightButtons = (this.state.isLoggedIn) ? [
      <Button iconName="user" className="pt-minimal" text={firebase.auth().currentUser.email} />,
      <button
        onClick={()=>{firebase.auth().signOut()}}
        className="pt-button pt-minimal pt-icon-log-out">
      </button>
    ] : null;

    return (
      <div className="pt-app app container">
        <nav className="pt-navbar pt-dark">
          <div className="pt-navbar-group pt-align-left">
            <div className="pt-navbar-heading">Media Brennt - TV</div>
            {leftButtons}
          </div>
          <div className="pt-navbar-group pt-align-right">
            {rightButtons}
          </div>
        </nav>
        <Page>
          {content}
        </Page>
      </div>
    );
  }
}

App.propTypes = {
}

export default App;



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/